import LocalizedStrings from 'react-localization';

export default new LocalizedStrings({
    en: {
        loginTitle: 'Log In',
        email: 'e-Mail',
        password: 'Password',
        loggingin: 'Logging in...',
        loggedin: 'Logged In!',
        loginfailed: 'Log In Failed - Retry?',
        login: 'Log In',
        loginErrorMessage: 'We were not able to find a user with that username and password',
        resetPassword: 'Forgot password?',
        registerQuestion: "Don't have an account?",
        register: 'Register',
        download: 'Download App',
        userNotConfirmedError:
            'User is not confirmed, please go to "New user? Register" and click on "Already registered? Confirm your registration"',
        userNotFoundError: 'No user with the supplied email address exists',
        codeDeliveryFailureException: 'The sent code has not been delivered to your email due to an error',
        invalidPasswordException: 'The password is invalid',
        usernameExistsException: 'A user already exists with this email',
        signUpCommonError: 'An error occurred while trying to register the new user',
        codeMismatchException: 'The provided code does not match what the expected',
        expiredCodeException: 'The provided code has expired',
        confirmSignUpCommonError: 'An error occurred while trying to confirm the new user',
        resendSignUpCommonError: 'An error occurred while trying to send the new confirmation code',
        forgotPasswordCommonError: 'An error occurred while trying to reset the password',
        signupTitle: 'Register User',
        confirmationCodeTitle: 'Confirmation Code',
        confirmationCodeMessage: 'Please check your email for the code.',
        newSignUpCode: 'Do you need a new code?',
        getNewCode: 'Send me a new one',
        verifying: 'Verifying...',
        verified: 'Verified!',
        verificationFailure: 'Verification Failed - Retry?',
        verify: 'Verify',
        name: 'Name',
        passwordPlaceholder: 'Your password',
        passwordRepeatPlaceholder: 'Retype your password',
        passwordSettingsTitle: 'Password settings',
        passwordSettingsRuleEqual: 'Passwords must be equal ',
        passwordSettingsRuleMinimumLength: 'Has to be at least 8 chars long ',
        passwordSettingsRuleUpperCase: 'Must have at least one upper case letter ',
        passwordSettingsRuleLowerCase: 'Must have at least one lower case letter ',
        passwordSettingsRuleNumber: 'Must have at least one number ',
        passwordSettingsRuleEspecialChar: 'Must have at least one special character ',
        saving: 'Registering user...',
        saved: 'User Registered!',
        saveFailed: 'Error registering - Retry?',
        submit: 'Register User',
        nameErrorMessage: 'Name must not be empty!',
        emailErrorMessage: 'Email format is not correct!',
        directlyConfirm: 'Already registered? Confirm your registration',
        alreadyRegisteredError: 'A user already registered with this email address.',
        resetTitle: 'Reset Password',
        resetting: 'Resetting...',
        reset: 'Reset Password',
        profileDetails: 'My profile',
        fullName: 'Full name',
        company: 'Company',
        salute: 'Salutation',
        mr: 'Mr.',
        mrs: 'Mrs.',
        position: 'Position',
        country: 'Country',
        city: 'City',
        area: 'Area',
        area_inside_sales: 'Inside Sales',
        area_outdoor_sales: 'Outdoor Sales',
        area_marketing: 'Marketing',
        area_management: 'Management',
        area_product: 'Product',
        area_other: 'Other, please detail',
        area_other_fill: 'Other area',
        updateUserProfileData: 'Update profile information',
        updateUserProfileDataOK: 'User profile information updated',
        updateUserProfileDataError: 'Could not update user profile information, please check that all fields are correct',
        companyEmptyErr: 'Company field cannot be empty',
        countryEmptyErr: 'Country field cannot be empty',
        saluteEmptyErr: 'Salute field cannot be empty',
        areaEmptyErr: 'Area field cannot be empty',
    },
    es: {
        loginTitle: 'Iniciar Sesión',
        email: 'Correo electrónico',
        password: 'Contraseña',
        loggingin: 'Iniciando sesión...',
        loggedin: '¡Sesión iniciada!',
        loginfailed: 'Error iniciando sesión - ¿Volver a probar?',
        login: 'Iniciar Sesión',
        loginErrorMessage: 'El sistema no ha encontrado ningún usuario que corresponda con la dirección de correo o la contraseña',
        resetPassword: '¿Ha olvidado su contraseña?',
        registerQuestion: '¿No tiene cuenta?',
        register: 'Regístrese aquí',
        download: 'Descargue la app',
        userNotConfirmedError:
            'El usuario no está confirmado, vaya a "¿Usuario nuevo? Regístrese aquí" y haga clic en "¿Ya se ha registrado? Confirme el registro"',
        userNotFoundError: 'No existe ningún usuario con éste correo electrónico',
        codeDeliveryFailureException: 'El código enviado no se ha podido entregar a su correo electrónico debido a un error',
        invalidPasswordException: 'La contraseña no es valida',
        usernameExistsException: 'Ya existe un usuario registrado con éste correo electrónico',
        signUpCommonError: 'Se ha producido un error al intentar registrar el nuevo usuario',
        codeMismatchException: 'El código no coincide con el esperado',
        expiredCodeException: 'El código ha expirado',
        confirmSignUpCommonError: 'Se ha producido un error al intentar confirmar el nuevo usuario',
        resendSignUpCommonError: 'Se ha producido un error al intentar enviar el nuevo código de confirmación',
        forgotPasswordCommonError: 'Se ha producido un error al intentar resetear la contraseña',
        signupTitle: 'Registrar Usuario',
        confirmationCodeTitle: 'Código de Confirmación',
        confirmationCodeMessage: 'Compruebe su correo electrónico para el código.',
        newSignUpCode: '¿Necesita un nuevo código?',
        getNewCode: 'Envíame uno nuevo',
        verifying: 'Verificando...',
        verified: '¡Verificado!',
        verificationFailure: 'Error verificando - ¿Volver a probar?',
        verify: 'Verificar',
        name: 'Nombre',
        passwordPlaceholder: 'Tu contraseña',
        passwordRepeatPlaceholder: 'Repite la contraseña',
        passwordSettingsTitle: 'Requisitos de contraseña',
        passwordSettingsRuleEqual: 'Debe ser la misma contraseña ',
        passwordSettingsRuleMinimumLength: 'Mínimo 8 caracteres de longitud ',
        passwordSettingsRuleUpperCase: 'Al menos una letra mayúscula ',
        passwordSettingsRuleLowerCase: 'Al menos una letra minúscula ',
        passwordSettingsRuleNumber: 'Al menos un número ',
        passwordSettingsRuleEspecialChar: 'Al menos un carácter especial ',
        saving: 'Registrando usuario...',
        saved: '¡Usuario registrado!',
        saveFailed: 'Error registrando usuario - ¿Volver a probar?',
        submit: 'Registrar Usuario',
        nameErrorMessage: 'El nombre no puede estar vacío',
        emailErrorMessage: '¡El formato de la dirección de correo electrónico no es correcto!',
        directlyConfirm: '¿Ya se ha registrado? Confirme el registro',
        alreadyRegisteredError: 'El usuario ya está registrado con esta dirección de correo.',
        resetTitle: 'Recuperar Contraseña',
        resetting: 'Recuperando...',
        reset: 'Recuperar Contraseña',
        profileDetails: 'Mi perfil',
        fullName: 'Nombre y apellidos',
        company: 'Empresa',
        salute: 'Tratamiento',
        mr: 'Sr.',
        mrs: 'Sra.',
        position: 'Cargo',
        country: 'País',
        city: 'Ciudad',
        area: 'Área operativa',
        area_inside_sales: 'Vendedor interno',
        area_outdoor_sales: 'Vendedor de campo',
        area_marketing: 'Márqueting',
        area_management: 'Dirección',
        area_product: 'Producto',
        area_other: 'Otra, por favor indíquela',
        area_other_fill: 'Otra área',
        updateUserProfileData: 'Actualizar datos de usuario',
        updateUserProfileDataOK: 'Datos de usuario actualizados correctamente',
        updateUserProfileDataError:
            'No se han podido actualizar datos de usuario. Por favor, compruebe que todos los campos sean correctos',
        companyEmptyErr: 'El campo empresa no puede estar vacío',
        countryEmptyErr: 'El campo país no puede estar vacío',
        saluteEmptyErr: 'El campo tratamiento no puede estar vacío',
        areaEmptyErr: 'El campo área operativa no puede estar vacío',
    },
    de: {
        loginTitle: 'Anmelden',
        email: 'E-Mail',
        password: 'Passwort',
        loggingin: 'Anmeldung…',
        loggedin: 'Angemeldet!',
        loginfailed: 'Anmeldung fehlgeschlagen - versuchen Sie es erneut',
        login: 'Anmeldung',
        loginErrorMessage: 'Wir haben keinen User mit diesem User-Namen und diesem Passwort gefunden',
        resetPassword: 'Passwort vergessen?',
        registerQuestion: 'Haben Sie keinen Zugang?',
        register: 'Registrieren',
        download: 'App-Download',
        userNotConfirmedError:
            'Der User wurde noch nicht bestätigt, bitte gehen Sie zu "Neuer User? Hier registrieren" und klicken auf "Bereits registriert? Bestätigen Sie Ihre Registrierung."',
        userNotFoundError: 'Es existiert kein User mit der eingegebenen E-Mail-Adresse',
        codeDeliveryFailureException: 'Der gesendete Code wurde aufgrund eines Fehlers nicht an Ihre E-Mail zugestellt',
        invalidPasswordException: 'Das Passwort ist ungültig',
        usernameExistsException: 'Die E-Mail-Adresse wurde bereits von einem anderen User registriert',
        signUpCommonError: 'Es trat ein Fehler bei der User-Registrierung auf',
        codeMismatchException: 'Die eingegebenen Codes stimmen nicht überein',
        expiredCodeException: 'Der eingegebene Code ist abgelaufen',
        confirmSignUpCommonError: 'Es trat ein Fehler bei der Bestätigung des neuen Users auf',
        resendSignUpCommonError: 'Es trat ein Fehler beim Versand des neuen Bestätigungscodes auf',
        forgotPasswordCommonError: 'Es trat ein Fehler beim Versuch auf, das Passwort zurückzusetzen',
        signupTitle: 'User registrieren',
        confirmationCodeTitle: 'Bestätigungscode',
        confirmationCodeMessage: 'Bitte überprüfen Sie Ihren E-Mail-Posteingang, ob Sie den Code erhalten haben',
        newSignUpCode: 'Benötigen Sie einen neuen Code?',
        getNewCode: 'Neuen Code schicken',
        verifying: 'Überprüfung…',
        verified: 'Überprüft!',
        verificationFailure: 'Überprüfung fehlgeschlagen - versuchen Sie es erneut',
        verify: 'Bestätigen',
        name: 'Name',
        passwordPlaceholder: 'Ihr Passwort',
        passwordRepeatPlaceholder: 'Passwort wiederholen',
        passwordSettingsTitle: 'Passwort-Einstellungen',
        passwordSettingsRuleEqual: 'Beide Passwörter müssen identisch sein',
        passwordSettingsRuleMinimumLength: 'Mindestens 8 Zeichen lang',
        passwordSettingsRuleUpperCase: 'Mindestens ein Großbuchstabe',
        passwordSettingsRuleLowerCase: 'Mindestens ein Kleinbuchstabe',
        passwordSettingsRuleNumber: 'Mindestens eine Zahl',
        passwordSettingsRuleEspecialChar: 'Mindestens ein Sonderzeichen',
        saving: 'User-Registrierung…',
        saved: 'User registriert!',
        saveFailed: 'Fehler bei der Registrierung versuchen Sie es erneut',
        submit: 'User registrieren',
        nameErrorMessage: 'Name darf nicht leer sein!',
        emailErrorMessage: 'Das E-Mail-Format ist nicht korrekt!',
        directlyConfirm: 'Bereits registriert? Bestätigen Sie Ihre Registrierung',
        alreadyRegisteredError: 'Die E-Mail-Adresse wurde bereits von einem anderen User registriert',
        resetTitle: 'Passwort zurücksetzen',
        resetting: 'Wird zurückgesetzt…',
        reset: 'Passwort zurücksetzen',
        profileDetails: 'Mein Profil',
        fullName: 'Vollständiger Name',
        company: 'Firma',
        salute: 'Anrede',
        mr: 'Herr',
        mrs: 'Frau',
        position: 'Position',
        country: 'Land',
        city: 'Ort',
        area: 'Bereich',
        area_inside_sales: 'Vertrieb Innendienst',
        area_outdoor_sales: 'Vertrieb Außendienst',
        area_marketing: 'Marketing',
        area_management: 'Management',
        area_product: 'Produktbereich',
        area_other: 'Andere, bitte genauere Angaben',
        area_other_fill: 'Anderer Bereich',
        updateUserProfileData: 'Profilinformationen aktualisieren',
        updateUserProfileDataOK: 'User-Profilinformationen aktualisiert',
        updateUserProfileDataError:
            'Die User-Profilinformationen konnten nicht aktualisiert werden. Bitte überprüfen Sie, ob alle Angaben korrekt sind.',
        companyEmptyErr: 'Das Feld "Firma" darf nicht leer sein',
        countryEmptyErr: 'Das Feld "Land" darf nicht leer sein',
        saluteEmptyErr: 'Das Feld "Anrede" darf nicht leer sein',
        areaEmptyErr: 'Das Feld "Bereich" darf nicht leer sein',
    },
    fr: {
        loginTitle: 'Log In',
        email: 'Email',
        password: 'Mot de Passe',
        loggingin: 'Logging in...',
        loggedin: 'Logged In!',
        loginfailed: 'Echec de connexion - Réessayez?',
        login: 'Log In',
        loginErrorMessage: "Nous ne trouvons pas d'utilisateur à ce nom et ce mot de passe",
        resetPassword: 'Mot de passe oublié?',
        registerQuestion: "Vous n'avez pas de compte?",
        register: 'Enregistrez-vous',
        download: "Téléchargez l'App",
        userNotConfirmedError:
            'Le nom d\'utilisateur n\'est pas valide, merci vous rendre sur "Nouvel utilisateur? Enregistrez-vous" et cliquez sur "Déjà enregistré? Confirmez votre inscription"',
        userNotFoundError: "Nous ne trouvons d'utilisateur à ce nom avec ce mot de passe",
        codeDeliveryFailureException: "Le code de validation n'a pu être délivré sur votre adresse email suite à une erreur",
        invalidPasswordException: 'Mot de passe invalide',
        usernameExistsException: 'Un utilisateur existe déjà avec cet email',
        signUpCommonError: "Une erreur est apparue au moment d'enregistrer le nouvel utilisateur",
        codeMismatchException: 'Le code ne correspond pas',
        expiredCodeException: 'Le code a expiré',
        confirmSignUpCommonError: 'Une erreur est apparue au moment de confirmer le nouvel utilisateur',
        resendSignUpCommonError: "Une erreur est apparue au moment d'adresser le code de vérification",
        forgotPasswordCommonError: 'Une erreur est apparue au moment de régénérer le mot de passe',
        signupTitle: 'Enregistrement utilisateur',
        confirmationCodeTitle: 'Code de Confirmation',
        confirmationCodeMessage: 'Merci vérifiez vos email pour récupérer le code.',
        newSignUpCode: 'Souhaitez vous un nouveau code?',
        getNewCode: 'Envoyez-moi un nouveau code',
        verifying: 'Verification...',
        verified: 'Verifié',
        verificationFailure: 'Echec de Verification - Recommencez?',
        verify: 'Verification',
        name: 'Nom',
        passwordPlaceholder: 'Votre mot de passe',
        passwordRepeatPlaceholder: 'Ressaisissez votre mot de passe',
        passwordSettingsTitle: 'Gérez votre mot de passe',
        passwordSettingsRuleEqual: 'Les mots de passe doivent être identiques ',
        passwordSettingsRuleMinimumLength: 'Il doit comporter au moins 8 caractères',
        passwordSettingsRuleUpperCase: 'Il doit comporter au moins une lettre capitale',
        passwordSettingsRuleLowerCase: 'Il doit comporter au moins une lettre minuscule',
        passwordSettingsRuleNumber: 'Il doit comporter au moins un chiffre',
        passwordSettingsRuleEspecialChar: 'Il doit comporter au moins un caractère spécial',
        saving: "Enregistrement de l'utilisateur...",
        saved: 'Utilisateur enregistré!',
        saveFailed: "Erreur à l'enregistrement - Recommencez?",
        submit: "Enregistrement de l'utilisateur",
        nameErrorMessage: 'le champ Nom ne peut pas être vide!',
        emailErrorMessage: "Le format Email n'est pas correct!",
        directlyConfirm: 'Déjà enregistré? Confirmez votre enregistrement',
        alreadyRegisteredError: 'Un utilisateur a déjà été enregistré avec cet email.',
        resetTitle: 'Réinitialisez votre mot de passe',
        resetting: 'Reinitialisation...',
        reset: 'Réinitialisez votre mot de passe',
        profileDetails: 'Mon profil',
        fullName: 'Nom',
        company: 'Société',
        salute: 'Salutation',
        mr: 'Monsieur',
        mrs: 'Madame',
        position: 'Position',
        country: 'Pays',
        city: 'Ville',
        area: 'Secteur',
        area_inside_sales: 'Inside Sales',
        area_outdoor_sales: 'Outdoor Sales',
        area_marketing: 'Marketing',
        area_management: 'Management',
        area_product: 'Product management',
        area_other: 'Autre, merci précisez',
        area_other_fill: 'Autre secteur',
        updateUserProfileData: 'Mettre à jour les informations de votre profil',
        updateUserProfileDataOK: 'Profil utilisateur mis à jour',
        updateUserProfileDataError: 'Mise à jour du profil impossible, merci vérifier que les champs à compléter sont corrects',
        companyEmptyErr: 'Le nom de la Société ne peut pas être vide',
        countryEmptyErr: 'Le nom du Pays ne peut pas être vide',
        saluteEmptyErr: 'La boîte Salutation ne peut pas être vide',
        areaEmptyErr: 'La boîte Domaine ne peut pas être vide',
    },
});
